import React from "react";
import { Bar } from 'react-chartjs-2';

const TopProduct = ({ topProductsChart }) => (
    <div className="bg-white shadow rounded-xl p-6 flex flex-col w-full">
        <div className="flex items-center justify-between mb-2">
            <h2 className="text-lg font-semibold text-gray-800">Top 10 Products</h2>
        </div>
        <div className="w-full h-80">
            <Bar data={topProductsChart} options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    title: { display: false },
                },
                scales: {
                    x: { title: { display: true, text: 'Product', font: { size: 12 } }, ticks: { font: { size: 12 } } },
                    y: { title: { display: true, text: 'Quantity Sold', font: { size: 12 } }, ticks: { font: { size: 12 } } },
                },
            }} />
        </div>
    </div>
);

export default TopProduct;
